export enum Source {
    Cohere = 'Cohere',
    LLama2 = 'LLama2',
    HeatwaveMistral = 'HeatwaveMistral',
    HeatwaveLlAMA2 = 'HeatwaveLlAMA2'
}